var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172.68 169.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8faaf7;}.cls-2{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_5);}.cls-3{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_5-2);}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_5",
    x1: 42.06,
    y1: 38.74,
    x2: 119.54,
    y2: 38.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c73e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#766acb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_5-2",
    x1: 5.44,
    y1: 85.96,
    x2: 154.37,
    y2: 85.96,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.3,169.11,7.64,135.8a11.9,11.9,0,0,1-7.49-13L17.74,17c1.53-9.22,8.33-15.1,15.14-12.8L166,49.12c6.8,2.3,8.65,11.09,4.27,19.36l-50.2,94.87C117.49,168.29,111.34,170.82,106.3,169.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.8,0a38.74,38.74,0,1,0,38.74,38.74A38.74,38.74,0,0,0,80.8,0Zm0,69.83a30.72,30.72,0,1,1,30.72-30.72A30.73,30.73,0,0,1,80.8,69.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.89,147.16h-96a11,11,0,0,1-10.36-9.11L5.7,40.41C4.32,31.9,8.53,24.77,15.14,24.77H144.67c6.61,0,10.82,7.13,9.44,15.64l-15.87,97.64A11,11,0,0,1,127.89,147.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.06,81.32H95.39V61.15a5.72,5.72,0,0,0-.65-3.22A2.7,2.7,0,0,0,92.4,57q-3.15,0-3.15,4.16V81.32H70.59V61.15a5.61,5.61,0,0,0-.67-3.22,2.78,2.78,0,0,0-2.37-.9q-3.1,0-3.1,4.16V81.32H45.79v-23q0-6.28,5.64-10.7A21.5,21.5,0,0,1,65.1,43.2,23.28,23.28,0,0,1,80,48.44q7.34-5.23,14.67-5.24,9.35,0,15,5.09,4.44,4,4.44,11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.17,100.79H45.8v-11h67.85v14.36a17,17,0,0,1-7.85,14.8q-9.4,6.34-25.5,6.35-15.42,0-25.15-5.43c-6.5-3.62-9.31-7.89-9.31-13.59,0-.67-.17-4,0-5.47H65.53v3.56q0,9.63,14.77,9.64,13.86,0,13.87-9.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.8a354933fbd3eb6e61a7d7a930ff6ded.svg";
export { ForwardRef as ReactComponent };